<template>
	<div class="content-wrap">

		<mq-layout mq="mobile">
			<MobileFrame></MobileFrame>
		</mq-layout>
		<mq-layout mq="laptop+">
			<LaptopFrame></LaptopFrame>
		</mq-layout>


	</div>

</template>
<script>
import LaptopFrame from './EducatorLaptop'
import MobileFrame from './EducatorMobile'

export default {
  name: 'educator',
  components:{LaptopFrame,MobileFrame},
  data () {
	    return {

	    }
	}
}
</script>
<style  scoped>
.content-wrap{
	position: relative;
	width:100%;
}


</style>



// WEBPACK FOOTER //
// src/pages/educator/Educator.vue